export const ORDER_ON_PROGRESS_STATUS = [
  "new",
  "pending",
  "estimate",
  "approved",
];

export const ORDER_ON_PRODUCTION_ALLOWED_ROUTES = [/\/design$/];
